export const MASTER_USER_ROLE = 'Master'
export const MANAGER_USER_ROLE = 'Gestor'
export const MEMBER_USER_ROLE = 'Membro'
export const USER_ROLES = [
  MASTER_USER_ROLE,
  MANAGER_USER_ROLE,
  MEMBER_USER_ROLE,
]
